import {
  TREE,
  BRANCH,
} from '../constants'

import traverse from 'fc-utils/traverse'

export default traverse([TREE, BRANCH])
